import React from 'react';
import { useTranslate } from '@hooks';
import { ModalWithInitialButton } from '@dotone/react-ui-core';
import Form from './AffiliateInternalNotesForm';

const AffiliateInternalNotesFormModal = ({ affiliate, ...otherProps }) => {
  const { t } = useTranslate('affiliate', 'model');

  const defaultValues = {
    affiliateId: affiliate.id,
    internalNotes: affiliate.preference?.internalNotes,
  };

  return (
    <ModalWithInitialButton
      dense
      title={t('internalNotes')}
      footer={false}
      form={<Form defaultValues={defaultValues} />}
      {...otherProps}
    />
  );
};

export default AffiliateInternalNotesFormModal;
